namespace GeniuzPOS.Inventory {
    export interface IcStockApproveDisassembleDtForm {
    }

    export class IcStockApproveDisassembleDtForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.IcStockApproveDisassembleDt';
    }
}
